// extracted by mini-css-extract-plugin
export default {"widget":"widget__FNHz2GF0"};